// Update inventory note; variant specs; price
let addToCartForm = document.querySelector('form[action="/cart/add"]');
addToCartForm?.addEventListener("change", (e) => {
  let formSelect = addToCartForm?.querySelector('select[name="id"]');
  let variantId = formSelect?.value;
  let mainProductSection = document.querySelector(".main-product");
  let mainProductSectionId = mainProductSection?.id.replace("shopify-section-", "");
  fetch(`${addToCartForm?.dataset.productUrl}?variant=${variantId}&section_id=${mainProductSectionId}`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");

      let elms = [
        ".storeFeatures",
        ".variant-specs",
        ".product-price__price",
        ".product-price__compare-price",
        ".product-single__save-amount",
        ".preorder-item__wrapper",
      ];

      elms.forEach((elm) => {
        let newElm = html.querySelector(elm);
        let currentElm = document.querySelector(elm);
        if (currentElm && newElm) currentElm.innerHTML = newElm.innerHTML;
      });
    });
});

// update cart inventory note
const slideCartObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    // Check if the mutation type is attributes and the attribute modified is 'class'
    if (mutation.type === "attributes" && mutation.attributeName === "class") {
      // Check if the target element now contains the 'active' class
      if (mutation.target.classList.contains("active")) {
        getCurrentCart();
      }
    }
  });
});

let slideCart = document.querySelector("#cart-drawer");
slideCartObserver.observe(slideCart, { attributes: true });

const slideCartTotalObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    // Check if the mutation type is characterData or childList
    if (mutation.type === "characterData" || mutation.type === "childList") {
      getCurrentCart();
    }
  });
});

let slideCartTotal = document.querySelector("#cart-drawer .minicartTol .product-price");
slideCartTotalObserver.observe(slideCartTotal, {
  characterData: true,
  childList: true,
  subtree: true,
});


function getCurrentCart() {
  fetch("/")
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      let scriptTag = html.querySelector("#cartItems");
      let cartData;
      if (scriptTag) {
        cartData = JSON.parse(scriptTag.textContent);
      }

      // cartData = cartData.filter((item) => item.is_nieuwkoop == true);
      if (cartData?.length > 0) {
        for (const [index, item] of cartData.entries()) {
          let cartItem = document.querySelector(`[cart-variant-id="${item.variant_id}"]`);

          if (!item.is_nieuwkoop) {
            if (cartItem) cartItem.innerHTML = "";
            continue;
          }

          if (
            item.internal_inventory &&
            item.cart_quantity > item.internal_inventory_quantity &&
            item.cart_quantity <= item.internal_inventory_quantity + item.external_inventory_quantity
          ) {
            if (cartItem)
              cartItem.innerHTML = `Skladem máme pouze ${item.internal_inventory_quantity} ks. Ostatní kusy jsou na externím skladě. Objednávku odešleme do týdne.`;
          } else if (item.internal_inventory && item.cart_quantity > item.internal_inventory_quantity + item.external_inventory_quantity) {
            if (cartItem && item.available_date) {
              if (item.uncertain_wait_time) {
                cartItem.innerHTML = `Skladem: ${item.internal_inventory_quantity} ks. Externí sklad: ${item.external_inventory_quantity} ks. <br> Kontaktujte nás pro informace o dostupnosti ostatních kusů.`;
              } else {
                cartItem.innerHTML = `Skladem: ${item.internal_inventory_quantity} ks. Externí sklad: ${item.external_inventory_quantity} ks. <br> Ostatní kusy budou dostupné od ${item.available_date}.`;
              }
            }
          } else {
            if (cartItem) cartItem.innerHTML = "";
          }

          if (!item.internal_inventory && item.external_inventory) {
            if (cartItem) cartItem.innerHTML = `Zboží na externím skladě; odešleme do týdne.`;
          }

          // if (!item.internal_inventory && !item.external_inventory) {
          //   if (cartItem) cartItem.innerHTML = `Předobjednávka`;
          // }
        }
      }
    });
}

// observe change in element bss-b2b-item-original-price
const originalPriceObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    const originalPrice = mutation.target.innerText;
    const originalPriceNumber = convertTextPriceToNumber(originalPrice);
    const originalPriceExclVat = parseInt((originalPriceNumber / 1.21) * 100) / 100;
    const itemKey = mutation.target.getAttribute("bss-b2b-cart-item-key");
    const itemExclVatElm = document.querySelector(`.item-excl-vat[data-item-key="${itemKey}"]`);
    if (itemExclVatElm) {
      itemExclVatElm.innerText = formatPrice(originalPriceExclVat);
    }
  });
});

const originalPrice = document.querySelectorAll("[bss-b2b-item-original-price]");
if (originalPrice.length > 0) {
  originalPrice.forEach((price) => {
    originalPriceObserver.observe(price, {
      childList: true,
      subtree: true,
    });
  });
}

// observe change in element bss-b2b-cart-total-price
const cartTotalObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    const cartTotal = mutation.target.innerText;
    const cartTotalNumber = convertTextPriceToNumber(cartTotal);
    const cartTotalExclVat = parseInt((cartTotalNumber / 1.21) * 100) / 100;
    const cartTotalExclVatElm = document.querySelector(".cart__subtotal-excl-vat");
    if (cartTotalExclVatElm) {
      cartTotalExclVatElm.innerText = formatPrice(cartTotalExclVat);
    }
  });
});

let cartTotal = document.querySelector(".cart__subtotal");
if (cartTotal) {
  cartTotalObserver.observe(cartTotal, {
    characterData: true,
    childList: true,
    subtree: true,
  });
}

// observe change in element bss-b2b-product-price
const productPriceObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    const productPrice = mutation.target.innerText;
    const productPriceNumber = convertTextPriceToNumber(productPrice);
    const productPriceExclVat = parseInt((productPriceNumber / 1.21) * 100) / 100;
    const productPriceExclVatElm = document.querySelector(".price-excl-vat span");
    if (productPriceExclVatElm) {
      productPriceExclVatElm.innerText = formatPrice(productPriceExclVat);
    }
  });
});

let productPrice = document.querySelector(".product-single__price");
if (productPrice) {
  productPriceObserver.observe(productPrice, {
    characterData: true,
    childList: true,
    subtree: true,
  });
}

function convertTextPriceToNumber(price) {
  return parseFloat(price.replace(/[^0-9]/g, ""));
}

function formatPrice(price) {
  let currencyFormatter = new Intl.NumberFormat("cs", {
    style: "currency",
    currency: Shopify.currency.active,
    currencyDisplay: "symbol",
    minimumFractionDigits: window.themeVariables.settings.moneyFormat.includes("no_decimals") ? 0 : 2,
    maximumFractionDigits: window.themeVariables.settings.moneyFormat.includes("no_decimals") ? 0 : 2,
  });
  return currencyFormatter.format(price);
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const cartNoteTextarea = document.getElementById("CartSpecialInstructions");
cartNoteTextarea.addEventListener(
  "input",
  debounce((e) => {
    updateCartNote(e.target.value);
  }, 1000)
);

cartNoteTextarea.addEventListener(
  "change",
  debounce((e) => {
    updateCartNote(e.target.value);
  }, 1000)
);

function updateCartNote(note) {
  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ note: note }),
  });
}